//imports
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';

//Action types
import {
    MANUFACTURER_CREATE_REQUEST,
    MANUFACTURER_EDIT_REQUEST,
    MANUFACTURER_GET_REQUEST,
} from 'Redux/actionTypes';

//Actions
import {
    manufacturerCreateResult,
    manufacturerEditResult,
    manufacturerGetResult,
    
} from 'Redux/actions';

function* getManufacturer({ payload }) {
    try {
        let QUERY = `
            query getManufacturer ($id: Int!) {
                result: getManufacturer (id: $id) {
                    id
                    name
                    active
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                id: payload
            },
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(manufacturerGetResult(data.result))

    } catch (exc) {
        yield put(manufacturerGetResult())
        ExceptionManager(exc, 'Modules/manufacturers/views/.components/createEditManufacturer/redux/saga', 'getManufacturer');
    }
}

function* createManufacturer({ payload }) {
    try {
        let QUERY = `
            mutation createManufacturer ($name: String, $active: Boolean!) {
                result: createManufacturer (name: $name, active: $active) {
                    id
                    name
                    active
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(manufacturerCreateResult(data?.result))
        } else yield put(manufacturerCreateResult())

    } catch (exc) {
        yield put(manufacturerCreateResult())
        ExceptionManager(exc, 'Modules/manufacturers/views/.components/createEditManufacturer/redux/saga', 'createManufacturer', true);
    }
}

function* updateManufacturer({ payload }) {
    try {
        let QUERY = `
            mutation updateManufacturer ($id: Int!, $name: String, $active: Boolean!) {
                result: updateManufacturer (id: $id, name: $name, active: $active) {
                    id
                    name
                    active
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );
        yield put(manufacturerEditResult(data?.result));

    } catch (exc) {
        yield put(manufacturerEditResult())
        ExceptionManager(exc, 'Modules/manufacturers/views/.components/createEditManufacturer/redux/saga', 'updateManufacturer');
    }
}

function* watchManufacturerRequests() {
    yield takeEvery(MANUFACTURER_GET_REQUEST, getManufacturer);
    yield takeEvery(MANUFACTURER_CREATE_REQUEST, createManufacturer);
    yield takeEvery(MANUFACTURER_EDIT_REQUEST, updateManufacturer);
}

//Saga Export
export default function* rootSaga() {
    yield all([
        fork(watchManufacturerRequests)
    ]);
}